<template>
  <div>
    <!-- Content Row -->
    <div>
      <h5 class="vue-title pull-left custom-header" >
        <strong>{{ $t("DASHBOARD") }}</strong>
      </h5>
    </div>

    <div class="row">
      <br />
      <br />
    </div>

    <div class="row">
      <!-- Earnings (Monthly) Card Example -->
      <div class="col-xl-3 col-md-6 mb-4">
        <div class="card border-left-primary shadow h-100 py-2">
          <div class="card-body">
            <div class="row no-gutters align-items-center">
              <div class="col mr-2">
                <div
                  class="text-xs font-weight-bold text-primary text-uppercase mb-1"
                >
                  {{ $t("REGISTERDUSER") }}
                </div>
                <div class="h5 mb-0 font-weight-bold text-gray-800">
                  {{ membersCount.total_patient_count }}
                </div>
              </div>
              <div class="col-auto">
                <em class="fas fa-users fa-2x text-gray-300"></em>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Earnings (Monthly) Card Example -->
      <div class="col-xl-3 col-md-6 mb-4">
        <div class="card border-left-success shadow h-100 py-2">
          <div class="card-body">
            <div class="row no-gutters align-items-center">
              <div class="col mr-2">
                <div
                  class="text-xs font-weight-bold text-success text-uppercase mb-1"
                >
                  {{ $t("PARTNERS") }}
                </div>
                <div class="h5 mb-0 font-weight-bold text-gray-800">
                  {{ membersCount.partner_count }}
                </div>
              </div>
              <div class="col-auto">
                <em class="fas fa-dollar-sign fa-2x text-gray-300"></em>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Earnings (Monthly) Card Example -->
      <div class="col-xl-3 col-md-6 mb-4">
        <div class="card border-left-info shadow h-100 py-2">
          <div class="card-body">
            <div class="row no-gutters align-items-center">
              <div class="col mr-2">
                <div
                  class="text-xs font-weight-bold text-info text-uppercase mb-1"
                >
                  Tasks
                </div>
                <div class="row no-gutters align-items-center">
                  <div class="col-auto">
                    <div class="h5 mb-0 mr-3 font-weight-bold text-gray-800">
                      50%
                    </div>
                  </div>
                  <div class="col">
                    <div class="progress progress-sm mr-2">
                      <div
                        class="progress-bar bg-info prg-bar"
                        role="progressbar"
                        aria-valuenow="50"
                        aria-valuemin="0"
                        aria-valuemax="100"
                      ></div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-auto">
                <em class="fas fa-clipboard-list fa-2x text-gray-300"></em>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Pending Requests Card Example -->
      <div class="col-xl-3 col-md-6 mb-4">
        <div class="card border-left-warning shadow h-100 py-2">
          <div class="card-body">
            <div class="row no-gutters align-items-center">
              <div class="col mr-2">
                <div
                  class="text-xs font-weight-bold text-warning text-uppercase mb-1"
                >
                  Pending Requests
                </div>
                <div class="h5 mb-0 font-weight-bold text-gray-800">18</div>
              </div>
              <div class="col-auto">
                <em class="fas fa-comments fa-2x text-gray-300"></em>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { GET_MIG_USERS_COUNT } from "@/store/actions.type";
import { pickAs } from "@/shared/utils.js";

export default {
  name: "migdashboard",
  components: {},
  data: function() {
    return {
      pickAs: pickAs,
      membersCount: {
        partner_count: 0,
        total_patient_count: 0
      }
    };
  },
  async created() {
    let data = await this.$store.dispatch(GET_MIG_USERS_COUNT);
    let dashboard = data.dashboard;
    this.membersCount = this.pickAs(dashboard, {
      partner_count: "partner_count",
      total_patient_count: "total_patient_count"
    });
  }
};
</script>
<style lang="scss">

.prg-bar{
  width: 50%
}
</style>
